import Keycloak from "keycloak-js";
import config from "../config";
export const keycloak = new Keycloak({
  url: config.keycloak.url,
  clientId: config.keycloak.clientId,
  realm: config.keycloak.realm, 
});

